import { Component } from '@angular/core';
import { setTheme } from 'ngx-bootstrap/utils';
import { AlertService } from './shared/services/alert.service';
import { TokenStorageService } from './auth/shared/services/token-storage.service';
import { OfficeTimezoneService } from './auth/shared/services/office-timezone.service';
import {UserInterface} from './shared/interfaces/user.interface';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent {
  title = 'can-washers-admin';
  public userProfile: UserInterface;
  public customerId: number;
  showAlert$ = this.alertService.showAlert$;

  constructor(
    private alertService: AlertService,
    private tokenStorage: TokenStorageService,
    private officeTimezoneService: OfficeTimezoneService
  ) {
    setTheme('bs5');
    this.officeTimezoneService.refresh(); // JOB-4193
    // this.alertService.handleApiResponse(0);
  }

  get isLoggedIn(): boolean {
    return !!this.tokenStorage.getToken();
  }
}
